import { Injectable } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';

@Injectable({
  providedIn: 'root',
})
export class BetService {
  raceDetailsForm: FormGroup;
  minStake = 0.5;
  selectedStake = this.minStake;
  selectedStakeChangeEvent$ = new Subject();
  formValidationEvent$ = new Subject();
  showConfirmBetPopupEvent$ = new Subject();
  totalPrice: number;
  numberofBets: number;
  placeBetSpinner: boolean;

  allAddedBetsInCart$ = new BehaviorSubject([]);
  showCurrentBet$ = new BehaviorSubject(true);
  totalAllBetsOnCart = 0;

  subscription: Subscription;

  constructor(private formBuilder: FormBuilder, private authService: AuthService) {
    this.subscription = this.authService.currentCountry$.subscribe((country) => {
      if (country) {
        this.selectedStake = country.minStakes;
        this.minStake = country.minStakes;
      }
    });
  }

  resetSelectedState() {
    this.selectedStake = this.minStake;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  stakeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const hasErr = control.value >= this.minStake ? false : true;
      if (hasErr) {
        return { stakeVal: true };
      }
      return null;
    };
  }


  initRaceDetailsForm(): void {
    this.raceDetailsForm = this.formBuilder.group({
      selectedStake: [
        this.selectedStake,
        Validators.compose([Validators.required, this.stakeValidator()]),
      ],
    });
    this.raceDetailsForm.get('selectedStake').valueChanges.subscribe((val) => {
      this.selectedStakeChangeEvent$.next(val);
    });
    this.raceDetailsForm.get('selectedStake').statusChanges.subscribe((val) => {
      this.formValidationEvent$.next(val === 'VALID' ? true : false);
    });
  }

  increase(): void {
    this.raceDetailsForm.controls.selectedStake.patchValue(
      this.selectedStake * 1 + 1
    );
  }

  decrease(): void {
    if (this.selectedStake === 0) return;
    let val = this.selectedStake * 1 - 1;
    val = val < 1 ? 1 : val;
    this.raceDetailsForm.controls.selectedStake.patchValue(val);
  }
}
